import InputSearchView from './input-serach-view'

export default InputSearchView
